'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ZINDEX_GROUP_LEVEL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _iBem = require('../i-bem/i-bem.react');

var _iBem2 = _interopRequireDefault(_iBem);

var _bPopup2MThemeNormal = (require('./../popup2/popup2.react.js'), (require('./../popup2/_theme/popup2_theme_normal.react.js').default || require('./../popup2/_theme/popup2_theme_normal.react.js')).applyDecls());

var _bPopup2MThemeNormal2 = _interopRequireDefault(_bPopup2MThemeNormal);

var _popup = require('../popup2/popup2.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ZINDEX_GROUP_LEVEL = exports.ZINDEX_GROUP_LEVEL = 20;

exports.default = (0, _iBem.decl)(_bPopup2MThemeNormal2.default, {
    block: 'modal',
    willInit: function willInit(_ref) {
        var zIndexGroupLevel = _ref.zIndexGroupLevel;

        this.__base.apply(this, arguments);
        // CSS-свойство z-index в модальном окне будут начинаться от (zIndexGroupLevel + 1) * 1000
        this._zIndexGroupLevel = zIndexGroupLevel || ZINDEX_GROUP_LEVEL;
    },
    mix: function mix(_ref2) {
        var visible = _ref2.visible,
            autoclosable = _ref2.autoclosable,
            direction = _ref2.direction;

        var mix = [].concat(this.__base.apply(this, arguments) || []);
        return [].concat(_toConsumableArray(mix), [{
            block: 'popup2',
            mods: {
                autoclosable: this.__self.bool2string(autoclosable),
                visible: this.__self.bool2string(visible),
                direction: direction
            }
        }]);
    },
    mods: function mods(_ref3) {
        var autoclosable = _ref3.autoclosable,
            theme = _ref3.theme,
            visible = _ref3.visible;

        var mods = this.__base.apply(this, arguments);
        return _extends({}, mods, {
            autoclosable: this.__self.bool2string(autoclosable),
            visible: this.__self.bool2string(visible),
            theme: theme
        });
    },
    content: function content(_ref4) {
        var _this = this;

        var children = _ref4.children,
            verticalAlign = _ref4.verticalAlign;

        return _react2.default.createElement(
            _iBem2.default,
            { block: 'modal', elem: 'table' },
            _react2.default.createElement(
                _iBem2.default,
                {
                    block: 'modal',
                    elem: 'cell',
                    attrs: {
                        style: { verticalAlign: verticalAlign }
                    } },
                _react2.default.createElement(
                    _iBem2.default,
                    {
                        block: 'modal',
                        elem: 'content',
                        attrs: {
                            ref: function ref(_ref5) {
                                return _this._contentElement = (0, _reactDom.findDOMNode)(_ref5);
                            }
                        } },
                    children
                )
            )
        );
    }
}, {
    defaultProps: {
        target: 'position',
        position: { left: 0, top: 0 },
        theme: 'normal',

        // FIXME: https://github.com/bem/bem-react-core/issues/13 – @grape
        directions: _popup.AVAILABLE_DIRECTIONS,
        mainOffset: 0,
        secondaryOffset: 0,
        viewportOffset: 0,
        zIndexGroupLevel: 0
    }
});